module.exports = __webpack_public_path__ + "static/media/logo-iskon.a3f3f211.svg";